const PARTNER_STORAGE_KEY = 'foth_partner_code';
const LEGACY_STORAGE_KEY = 'foth_affiliate_code';

export const normalizePartnerCode = (value) => (
  (value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
);

export const storePartnerCode = (code) => {
  const normalizedCode = normalizePartnerCode(code);
  if (!normalizedCode) return '';
  localStorage.setItem(PARTNER_STORAGE_KEY, normalizedCode);
  localStorage.setItem(LEGACY_STORAGE_KEY, normalizedCode);
  return normalizedCode;
};

export const getStoredPartnerCode = () => (
  localStorage.getItem(PARTNER_STORAGE_KEY) || localStorage.getItem(LEGACY_STORAGE_KEY) || ''
);

export const clearStoredPartnerCode = () => {
  localStorage.removeItem(PARTNER_STORAGE_KEY);
  localStorage.removeItem(LEGACY_STORAGE_KEY);
};
